<script setup lang="ts">
import {
  getDateBgColor,
  vesselActualDateFormatter,
  vesselActualTimeFormatter,
  getDateIconColor,
  getDateIcon
} from "@/utils/date_formatter";
const props = defineProps({
  id: {
    type: String,
    required: true,
    default: ""
  },
  actual: {
    type: String,
    required: true,
    default: ""
  },
  estimated: {
    type: String,
    required: true,
    default: ""
  },
  showETA: {
    type: Boolean,
    required: false,
    default: false
  },
  sendDeparture: {
    type: Boolean,
    required: false,
    default: false
  }
});
</script>

<template>
  <div :slot="id" class="time-container" :class="props.showETA ? getDateBgColor(props.actual, props.estimated) : ''">
    <div class="date-time-container">
      <div class="vessel-time">
        <span>{{ vesselActualDateFormatter(props.actual, props.estimated) }}</span>
      </div>
      <div class="vessel-date">
        <span> {{ vesselActualTimeFormatter(props.actual, props.estimated) }}</span>
      </div>
    </div>
    <div v-if="props.showETA">
      <mc-icon
        :icon="getDateIcon(props.actual, props.estimated)"
        :color="getDateIconColor(props.actual, props.estimated)"
        size="20"
      ></mc-icon>
    </div>
  </div>
</template>

<style lang="css" scoped>
.actual {
  background: #ffefec;
  border-bottom: 5px solid #ff6441;
  padding: 0 5px;
}
.estimated {
  border-bottom: 5px solid #42b0d5;
  padding: 0 5px;
}
.vessel-date {
  font-weight: bold;
}
</style>
